/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    // var variant = event.detail.variant;
    // var container = event.target;
    // if (variant) {
    //   console.log('Container ———————— ↓');
    //   console.log(container);
    //   console.log('Variant —————————— ↓');
    //   console.log(variant);
    //   // ... update some element on the page
    // }
  });

  document.addEventListener('theme:cart:change', function(event) {
    // var cart = event.detail.cart;
    // if (cart) {
    //   console.log('Cart ———————————— ↓');
    //   console.log(cart);
    //   // ... update an app or a custom shipping caluclator
    // }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    // console.log('theme:cart:init');
    // console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
  const closeAnnouncementButton = document.getElementById('close-announcement-bar')
  const announcementBar = document.querySelector('#shopify-section-announcement>.announcement__wrapper');
  if(closeAnnouncementButton){
    closeAnnouncementButton.addEventListener('click',(e)=>{
      e.preventDefault();
      announcementBar.classList.add('display-none');
      announcementBar.ariaHidden = "true";
      document.body.style.setProperty('--ANNOUNCEMENT-BAR-HEIGHT', '0');
      window.sessionStorage.setItem('hideAnnouncement', `${Date.now() + 86400000}`);
    })
  }

  $('[data-section-type="custom-content"] h2 span').wrapAll('<div class="custom-span-wrapper"></div>');
  $(function () {
      var $lis = $('[data-section-type="custom-content"] h2 span'),
      $cur = $lis.first().addClass('active'),
      $next = $cur.next().addClass('next');
      let targetHeight = $cur.height();
       $('[data-section-type="custom-content"] .custom-span-wrapper').height(targetHeight);
      $cur.fadeIn(500);
      setInterval(function () {
         $cur.fadeOut({duration: 500,queue: false}).removeClass('active');
         $cur = $next.removeClass('next').fadeIn({duration: 500,queue: false}).addClass('active'); 
         let targetHeight = $cur.height();
         $('[data-section-type="custom-content"] .custom-span-wrapper').height(targetHeight);
          $next = $cur.next();
          if (!$next.length) {
              $next = $lis.first();
          }
          $next.addClass('next');
      }, 3000);
  });

})();

function refreshCustomContent() {
  $('[data-section-type="custom-content"] h2 span').wrapAll('<div class="custom-span-wrapper"></div>');
  $(function () {
      var $lis = $('[data-section-type="custom-content"] h2 span'),
      $cur = $lis.first().addClass('active'),
      $next = $cur.next().addClass('next');
      $cur.fadeIn(500);
      setInterval(function () {
         $cur.fadeOut({duration: 500,queue: false}).removeClass('active');
         $cur = $next.removeClass('next').fadeIn({duration: 500,queue: false}).addClass('active'); 
          $next = $cur.next();
          if (!$next.length) {
              $next = $lis.first();
          }
          $next.addClass('next');
      }, 3000);
  });
}

document.addEventListener("shopify:section:load", this.refreshCustomContent);
document.addEventListener("shopify:section:reorder", this.refreshCustomContent);
document.addEventListener("shopify:block:select", this.refreshCustomContent);
document.addEventListener("shopify:block:deselect", this.refreshCustomContent);


document.addEventListener('theme:variant:change', function(event) {
  let selectedVariant = $(event.target).find('input[name="id"]').val()
  let selectedVariantMessage = $(event.target).find('[variant-id="' + selectedVariant + '"]').attr('variant-id-message');
  if (selectedVariantMessage) {
    $('.product__submit__buttons').addClass('pre-order-button');
    $('.product__submit__buttons .pre-order-message').hide();
    $('.product__submit__buttons .pre-order-message[variant-id="' + selectedVariant + '"]').show();
    $('[name="properties[Null]"]').attr( 'name','properties[Pre-Order]');
    $('[name="properties[Pre-Order]"]').val(selectedVariantMessage);
  } else {
    $('.product__submit__buttons').removeClass('pre-order-button');
    $('.product__submit__buttons .pre-order-message').hide();
    $('[name="properties[Pre-Order]"]').attr( 'name','properties[Null]');
    $('[name="properties[Null]"]').val(selectedVariantMessage);
  }
});


document.addEventListener('DOMContentLoaded', function() {

  document.documentElement.style.setProperty('--resize-header-height', `${Math.round(document.querySelector('[data-header-height]').clientHeight)}px`);

  // Get the element you want to scroll to
  const stampedReviewsWidget = document.getElementById('product-reviews');
  
  // Add a click event listener to the button
  const stampedReviewBadge = document.querySelector('.shopify-app-block .stamped-product-reviews-badge');
  stampedReviewBadge.addEventListener('click', () => {
    // Scroll to the target element smoothly
    stampedReviewsWidget.scrollIntoView({
      behavior: 'smooth' // Optional: for smooth scrolling
    });
  });

  
});

window.addEventListener('resize', function() {
  document.documentElement.style.setProperty('--resize-header-height', `${Math.round(document.querySelector('[data-header-height]').clientHeight)}px`);
});

const heightObserver = new ResizeObserver(entries => {
    // Callback function that runs when observed elements resize
    for (let entry of entries) {
        document.documentElement.style.setProperty('--resize-header-height', `${entry.contentRect.height}px`);
    }
});

const myElement = document.querySelector('[data-header-height]');
heightObserver.observe(myElement);
